import { Character } from '../graph/schema-generated-types-educator';
import LOG_API_ERROR from '../graph/mutations/log-api-error';
import Config from '../config';

export const formatPageNumber = (pageNumber: number | string | undefined): string | undefined => {
  if (typeof pageNumber === 'number') {
    return `${pageNumber}`;
  }
  return pageNumber;
};

export const formatCharacter = (character: Character) => {
  return {
    character: character.character,
    characterCase: character.characterCase,
    characterType: character.characterType,
    characterId: character.id,
  };
};

export const sendGraphErrorLog = (client, data) => {
  client
    .mutate({
      mutation: LOG_API_ERROR,
      variables: {
        data,
      },
      errorPolicy: 'ignore',
      fetchPolicy: 'network-only',
    })
    .catch((e) => console.error('ERROR WITH LOG ERROR MUTATION', e));
};

export const formatError = (graphQLError, networkError, operation) => {
  const { extensions, ...rest } = graphQLError;
  return {
    body: {
      operationName: operation.operationName,
      query: operation.extensions?.query ?? operation.extensions?.persistedQuery,
    },
    data: {
      ...rest,
      ...extensions,
    },
    method: 'POST',
    params: operation.variables,
    status: networkError?.statusCode,
    url: Config.graphUrl,
  };
};
